import Vue from 'vue'
import axios from 'axios'
import router from '@/router'
import qs from 'qs'
import * as Sentry from '@sentry/browser'

// Swagger:
// https://mapi-dev.kingnetsmart.com.tw/swagger/index.html#/Community/get_api_Community_ResidentIdentity
// https://mapi-dev.kingnetsmart.com.tw/swagger/index.html#/HouseholdProperty
const instance = axios.create({
  baseURL: `${process.env.VUE_APP_MAPI_URL}/`
})
instance.defaults.paramsSerializer = (params) => {
  return qs.stringify(params, { arrayFormat: 'repeat' })
}
// 佩穎之後似乎也會寫成共用函式
const genAlertIfNotExist = (msg, finallyCallback) => {
  // eslint-disable-next-line eqeqeq
  if (document.getElementsByClassName('v-modal').length == 0) {
    Vue.prototype
      .$alert(msg, '警告', {
        confirmButtonText: '確定',
        type: 'warning',
        showClose: false,
        roundButton: true,
        closeOnClickModal: false
      }).finally(() => {
        finallyCallback()
      })
  }
}
// 401 重新登入
const alertUnauthorized = () => {
  genAlertIfNotExist('登入過期或驗證失敗，請重新登入', () => {
    router.push({ name: 'LoginMain' })
  })
}
// 403 沒有啟用此服務
const alertForbidden = (service = '住戶資訊') => {
  genAlertIfNotExist(`未啟用${service}服務`, () => {
    Vue.prototype.$toMainPage()
  })
}
// 403 非最高管理者
const alertNotHighestAdmin = () => {
  genAlertIfNotExist('您並非最高權限管理者，無法進行此操作')
}
// 404 有可能為伺服器重新部署中、 409 為資料寫入衝突，應過一陣子就可以了
const alertTryAgainLater = (errorMessage = '請稍後再試') => {
  Vue.prototype.$message.error(errorMessage)
}
// 500
const alertServerError = (errorMessage = '伺服器發生錯誤') => {
  Vue.prototype.$message.error(errorMessage)
}
// 先照舊，之後再整合多個 Alert 的 Issue
instance.interceptors.request.use(
  (config) => {
    const newConfig = { ...config }
    if (Vue.prototype.$getCookie('comLoginToken')) {
      const webcookie = Vue.prototype.$getCookie('comLoginToken').split('token=').pop()
      const xCorrelationId = Vue.prototype.$getGuid()
      newConfig.headers = {
        authorization: webcookie,
        'X-Correlation-Id': xCorrelationId
      }
      Sentry.setTag('X-Correlation-Id', xCorrelationId)
      newConfig.metadata = { startTime: new Date() }
      return newConfig
    } else {
      alertUnauthorized()
    }
  },
  (err) => {
    return Promise.reject(err)
  }
)
// 先照舊，之後再整合多個 Alert 的 Issue
instance.interceptors.response.use(
  res => {
    const newRes = { ...res }
    newRes.config.metadata.endTime = new Date()
    newRes.duration =
      newRes.config.metadata.endTime - newRes.config.metadata.startTime
    return newRes
  },
  err => {
    const newErr = { ...err }
    newErr.config.metadata.endTime = new Date()
    newErr.duration =
      newErr.config.metadata.endTime - newErr.config.metadata.startTime
    if (newErr && newErr.response && newErr.response.status) {
      const { status } = newErr.response
      switch (status) {
        case 401:
          alertUnauthorized()
          break
        case 403:
          if (newErr.response.config.url.includes('SwitchNotification')) {
            alertNotHighestAdmin()
          } else {
            alertForbidden()
          }
          break
        case 404:
        case 409:
          alertTryAgainLater()
          break
        case 500:
          alertServerError()
          break
        default:
          if (err.response.data.ErrorMessage) {
            Vue.prototype.$message.error(err.response.data.ErrorMessage.Description)
          } else {
            alertTryAgainLater()
          }
          break
      }
    }
    return Promise.reject(newErr)
  }
)
export const apiHousehold = {
  // 戶別
  getRoles: () => instance.get('Community/ResidentIdentity'),
  getTransportations: () => instance.get('Community/Transportations'),
  getResident: (tabletId) => instance.get(`Community/Tablet/${tabletId}/Resident`),
  postResident: (tabletId, data, config) => instance.post(`Community/Tablet/${tabletId}/Resident`, data, config),
  putResident: (tabletId, id, data, config) => instance.put(`Community/Tablet/${tabletId}/Resident/${id}`, data, config),
  deleteResident: (tabletId, id, data, config) => instance.delete(`Community/Tablet/${tabletId}/Resident/${id}`, data, config),
  // 產權
  getPropertySampleExcel: () => instance.get('HouseholdProperty/Example/Export', {
    responseType: 'blob'
  }),
  postPropertyExcel: (data, config) => instance.post('HouseholdProperty/Import', data, config),
  getPropertyExcel: (config) => instance.get('HouseholdProperty/Export', {
    ...config,
    responseType: 'blob'
  }),
  getProperty: (tag) => instance.get('HouseholdProperty', {
    params: {
      Tag: tag
    }
  }),
  getPropertyById: (id) => instance.get(`HouseholdProperty/${id}`),
  putPropertyById: (id, data) => instance.put(`HouseholdProperty/${id}`, data),
  postPropertyById: (data) => instance.post('HouseholdProperty/', data),
  getManagerIdentifier: () => instance.get('ManagerIdentifier/Token') // 取得管理員QRCode
}
